export enum UserSelectionDataHooks {
  USER_SELECTION_SECTION_NOTIFICATION = 'user_selection_section_notification',
  USER_SELECTION_COMPONENT = 'user_selection',
  USER_SELECTION_BUTTON = 'user_selection_button',
  USER_SELECTION_TEXT = 'user_selection_text',
}
